import { Injectable, inject } from '@angular/core';
import ValidatorUtils from '@core/utils/validator.utils';
import {
  DvDatePickerLegacyElement,
  DvDropdownClientSideElement,
} from '@devinco/ui/legacy';
import { TranslateService } from '@ngx-translate/core';
import { ChartResolution } from '@pages/statistics-page/constants';
import { DvDynamicFormElement } from '@devinco/ui/legacy';
@Injectable({
  providedIn: 'root',
})
export class StatisticsMenuElementService {
  private translateService = inject(TranslateService);

  getElements(): DvDynamicFormElement[] {
    return [
      new DvDropdownClientSideElement({
        colspan: 12,
        key: 'resolution',
        label: 'Statistics.Resolution',
        labelKeys: ['name'],
        valueKey: 'id',
        isClearable: false,
        items: [
          {
            id: ChartResolution.Day,
            name: this.translateService.instant('Statistics.Day'),
          },
          {
            id: ChartResolution.Week,
            name: this.translateService.instant('Statistics.Week'),
          },
          {
            id: ChartResolution.Month,
            name: this.translateService.instant('Statistics.Month'),
          },
        ],
      }),
      new DvDatePickerLegacyElement({
        colspan: 12,
        key: 'dateFrom',
        label: 'Statistics.DateFrom',
        validators: [ValidatorUtils.dateRangeValidator('dateTo')],
        validationMessages: {
          'Validation.RangeEndError': this.translateService.instant(
            'Validation.RangeEndError'
          ),
        },
      }),
      new DvDatePickerLegacyElement({
        colspan: 12,
        key: 'dateTo',
        label: 'Statistics.DateTo',
        validators: [ValidatorUtils.dateTimeRangeEndValidator('dateFrom')],
      }),
    ];
  }
}
